/*
 * @Autor: lh
 * @Date: 2022-02-25 14:32:18
 * @LastEditors: lh
 * @LastEditTime: 2022-11-30 15:38:16
 * @Description: 封装请求方法
 */
import axios from 'axios'
import Api from '@/static/js/api.js';
import store from '@/store'
import { Toast } from "mint-ui";
import {getQueryString} from "@/static/js/common.js"
// post 封装方法
export function axiosPost(parameter) {
    let headers = parameter.headers || {
        token: getQueryString('token') || store.getters.userData.token,
    };
    return new Promise(function (resolve, reject) {
        axios({
            method: "post",
            url:Api.config.host + parameter.url,
            params: parameter.params,
            headers: headers,
        }).then(res => {
            res = res.data;
            console.log(res);
            if (res.code == 200) {
                resolve(res);
            }else{
                // Toast(res.msg || '请求失败,请联系客服')
            }
        }).catch(err => {
            // console.log(err.response)
            reject(err);
            try {
                if (err.response.data.error) {
                    Toast(err.response.data.error);
                }
            } catch (error) {

            }
        });
    });
}

// get封装方法
export function axiosGet(parameter) {
    let headers = parameter.headers || {
        token: getQueryString('token') || store.getters.userData.token,
    };
    return new Promise(function (resolve, reject) {
        axios.get(
            Api.config.host + parameter.url,
            {
                params: parameter.params,
                headers: headers,
            }
        ).then(res => {
            res = res.data;
            if (res.code == 200) {
                resolve(res);
            }
        }).catch(err => {
            // console.log(err.response)
            reject(err);
            try {
                if (err.response.data.error) {
                    Toast(err.response.data.error);
                }
            } catch (error) {

            }
        });
    });

}

// post 封装方法
export function apiPost(parameter) {
    let headers = parameter.headers || {
        token: store.getters.userData.token,
    };
    return new Promise(function (resolve, reject) {
        let axiosObj = {
            method: "post",
            url:Api.config.host + parameter.url,
            params: parameter.params,
            // data:parameter.params,
            headers: headers,
        }
        if(parameter.formdata) axiosObj.data = parameter.params
        axios(axiosObj).then(res => {
            resolve(res);
        }).catch(err => {
            // console.log(err.response)
            reject(err);
            try {
                if (err.response.data.error) {
                    Toast(err.response.data.error);
                }
            } catch (error) {

            }
        });
    });
}
// get封装方法
export function apiGet(parameter) {
    let headers = parameter.headers || {
        token:  store.getters.userData.token,
    };
    return new Promise(function (resolve, reject) {
        axios.get(
            Api.config.host + parameter.url,
            {
                params: parameter.params,
                headers: headers,
            }
        ).then(res => {
            resolve(res);
        }).catch(err => {
            // console.log(err.response)
            reject(err);
            try {
                if (err.response.data.error) {
                    Toast(err.response.data.error);
                }
            } catch (error) {

            }
        });
    });

}


export default {
    axiosPost,
    axiosGet
};



// WEBPACK FOOTER //
// ./src/static/js/request.js